<ng-container *transloco="let t">
 <ng-template #declaration>
  <div class="card shadow-sm mb-5">
    <div class="card-header">
        <h3 class="card-title">{{mainBorrower.firstName + " " + mainBorrower.lastName}}</h3>
    </div>
    <div class="card-body">
      <borrower-declarations #borrowerDeclarations
        [borrower]="mainBorrower"
        [fieldsToConfig]="step.fieldConfig">
      </borrower-declarations>
    </div>
  </div>

  @if (!inCoApplyFlow) {
    @for (borrower of coBorrowers; track borrower.borrowerId) {
      @if (borrowerSetting(borrower)) {
        <div class="card shadow-sm mb-5" >
            <div class="card-header">
              <h3 class="card-title">{{borrower.firstName + " " + borrower.lastName}}</h3>
            </div>
            <div class="card-body">
              <borrower-declarations #borrowerDeclarations
                [borrower]="borrower"
                [fieldsToConfig]="step.fieldConfig">
              </borrower-declarations>
            </div>
        </div>
      }
    }
  }

</ng-template>

<wizard-step-template [stepMainTemplate]="declaration" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
